
// import React, { useEffect, useState } from "react";
// import "../CSS/detail.css";
// import { RotateCcw } from "lucide-react";
// import logo from "../assets/logo.png";
// import "../CSS/logoutModal.css";

// function Detail() {
//   const [queue, setQueue] = useState([]);
//   const [current, setCurrent] = useState(null);
//   const [showLogoutModal, setShowLogoutModal] = useState(false);

//   // FETCH QUEUE
//   const fetchQueue = async () => {
//     try {
//       const res = await fetch("https://q-less.onrender.com/api/patient/queue");
//       const data = await res.json();

//       const sorted = data.sort(
//         (a, b) => Number(a.tokenNumber) - Number(b.tokenNumber)
//       );

//       setQueue(sorted);
//       setCurrent(sorted[0] || null);
//     } catch (err) {
//       console.log("Queue fetch error:", err);
//     }
//   };

//   // CLEAR TOKEN — Call backend API to delete from database
//   const clearToken = async () => {
//     if (queue.length === 0) return;

//     try {
//       const res = await fetch("https://q-less.onrender.com/api/patient/clear", {
//         method: "DELETE",
//       });

//       const data = await res.json();

//       if (res.ok) {
//         // Refresh queue after clearing
//         await fetchQueue();
//       } else {
//         console.error("Error clearing token:", data.message);
//         alert(data.message || "Failed to clear token");
//       }
//     } catch (err) {
//       console.error("Error clearing token:", err);
//       alert("Failed to clear token. Please try again.");
//     }
//   };

//   // LOGOUT CONFIRMATION HANDLERS
//   const confirmLogout = () => {
//     window.location.href = "/stafflogin";
//   };

//   const cancelLogout = () => {
//     setShowLogoutModal(false);
//   };

//   useEffect(() => {
//     fetchQueue();
//     // Auto-refresh queue every 5 seconds
//     const interval = setInterval(fetchQueue, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="cleartokenpage-container">

//       {/* HEADER */}
//       <header className="cleartokenpage-header">
//         <div className="cleartokenpage-header-left">
//           <img src={logo} alt="Q-Less Logo" className="cleartokenpage-logo" />
//         </div>

//         <div
//           className="cleartokenpage-header-right"
//           style={{ display: "flex", gap: "15px", alignItems: "center" }}
//         >
//           <RotateCcw
//             size={18}
//             className="cleartokenpage-refreshicon"
//             onClick={fetchQueue}
//             style={{ cursor: "pointer" }}
//           />

//           <button
//             onClick={() => setShowLogoutModal(true)}
//             style={{
//               background: "#ef4444",
//               color: "white",
//               padding: "6px 14px",
//               borderRadius: "8px",
//               border: "none",
//               cursor: "pointer",
//               fontWeight: "500",
//             }}
//           >
//             Logout
//           </button>
//         </div>
//       </header>

//       {/* LOGOUT MODAL */}
//       {showLogoutModal && (
//         <div className="logout-overlay">
//           <div className="logout-modal">
//             <h3>Are you sure you want to log out?</h3>

//             <div className="logout-buttons">
//               <button className="cancel-btn" onClick={cancelLogout}>
//                 Cancel
//               </button>

//               <button className="yes-btn" onClick={confirmLogout}>
//                 Yes
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* MAIN */}
//       <main className="cleartokenpage-main">

//         {/* CARD */}
//         <div className="cleartokenpage-card">
//           <div className="cleartokenpage-card-header">
//             <h2>Clear Current Token</h2>
//             <p>Mark the current patient as completed and advance the queue</p>

//             <h3>
//               Token Number: <span>{current ? current.tokenNumber : "—"}</span>
//             </h3>
//           </div>

//           {/* PATIENT INFO */}
//           {current ? (
//             <div className="cleartokenpage-info-card">
//               <h4>Patient Information</h4>

//               <div className="cleartokenpage-info-grid">
//                 <div>
//                   <p className="cleartokenpage-label">Name</p>
//                   <p className="cleartokenpage-value">{current.name}</p>
//                 </div>

//                 <div>
//                   <p className="cleartokenpage-label">CID</p>
//                   <p className="cleartokenpage-value">{current.cid}</p>
//                 </div>

//                 <div>
//                   <p className="cleartokenpage-label">DOB</p>
//                   <p className="cleartokenpage-value">{current.dob}</p>
//                 </div>

//                 <div>
//                   <p className="cleartokenpage-label">Age</p>
//                   <p className="cleartokenpage-value">{current.age}</p>
//                 </div>

//                 <div className="cleartokenpage-fullwidth">
//                   <p className="cleartokenpage-label">Chief Complaint</p>
//                   <p className="cleartokenpage-value">{current.complaint}</p>
//                 </div>
//               </div>
//             </div>
//           ) : (
//             <p className="no-queue">No patients in the queue.</p>
//           )}

//           <button className="cleartokenpage-btn" onClick={clearToken}>
//             Clear Token
//           </button>
//         </div>

//         {/* QUEUE OVERVIEW */}
//         <section className="cleartokenpage-queue">
//           <h3>Queue Overview</h3>
//           <p>Current status of your chamber</p>

//           <div className="cleartokenpage-queue-grid">
//             <div className="cleartokenpage-queue-box">
//               <p className="cleartokenpage-label">Location</p>
//               <p className="cleartokenpage-value">
//                 {current ? current.chamberAssignment : "—"}
//               </p>
//             </div>

//             <div className="cleartokenpage-queue-box">
//               <p className="cleartokenpage-label">Current Token</p>
//               <p className="cleartokenpage-value">
//                 {current ? current.tokenNumber : "—"}
//               </p>
//             </div>

//             <div className="cleartokenpage-queue-box">
//               <p className="cleartokenpage-label">Waiting</p>
//               <p className="cleartokenpage-value">
//                 {queue.length > 0 ? queue.length - 1 : 0}
//               </p>
//             </div>
//           </div>
//         </section>

//       </main>

//       <footer className="cleartokenpage-footer">
//         <p>Last Updated Just Now</p>
//         <span>© 2025 Q-Less. All Rights Reserved.</span>
//       </footer>
//     </div>
//   );
// }

// export default Detail;


import React, { useEffect, useState } from "react";
import "../CSS/detail.css";
import { RotateCcw } from "lucide-react";
import logo from "../assets/logo.png";
import "../CSS/logoutModal.css";

function Detail() {
  const [queue, setQueue] = useState([]);
  const [current, setCurrent] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // FETCH QUEUE
  const fetchQueue = async () => {
    try {
      const res = await fetch("https://q-less.onrender.com/api/patient/queue");
      const data = await res.json();

      const sorted = data.sort(
        (a, b) => Number(a.tokenNumber) - Number(b.tokenNumber)
      );

      setQueue(sorted);
      setCurrent(sorted[0] || null);
    } catch (err) {
      console.log("Queue fetch error:", err);
    }
  };

  // CLEAR TOKEN — Call backend API to delete from database
  const clearToken = async () => {
    if (queue.length === 0) return;

    try {
      const res = await fetch("https://q-less.onrender.com/api/patient/clear", {
        method: "DELETE",
      });

      const data = await res.json();

      if (res.ok) {
        // Refresh queue after clearing
        await fetchQueue();
      } else {
        console.error("Error clearing token:", data.message);
        alert(data.message || "Failed to clear token");
      }
    } catch (err) {
      console.error("Error clearing token:", err);
      alert("Failed to clear token. Please try again.");
    }
  };

  // LOGOUT CONFIRMATION HANDLERS
  const confirmLogout = () => {
    window.location.href = "/stafflogin";
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  useEffect(() => {
    fetchQueue();
    // Auto-refresh queue every 5 seconds
    const interval = setInterval(fetchQueue, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="cleartokenpage-container">

      {/* HEADER */}
      <header className="cleartokenpage-header">
        <div className="cleartokenpage-header-left">
          <img src={logo} alt="Q-Less Logo" className="cleartokenpage-logo" />
        </div>

        <div
          className="cleartokenpage-header-right"
          style={{ display: "flex", gap: "15px", alignItems: "center" }}
        >
          <RotateCcw
            size={18}
            className="cleartokenpage-refreshicon"
            onClick={fetchQueue}
            style={{ cursor: "pointer" }}
          />

          <button
            onClick={() => setShowLogoutModal(true)}
            style={{
              background: "#ef4444",
              color: "white",
              padding: "6px 14px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: "500",
            }}
          >
            Logout
          </button>
        </div>
      </header>

      {/* LOGOUT MODAL */}
      {showLogoutModal && (
        <div className="logout-overlay">
          <div className="logout-modal">
            <h3>Are you sure you want to log out?</h3>

            <div className="logout-buttons">
              <button className="cancel-btn" onClick={cancelLogout}>
                Cancel
              </button>

              <button className="yes-btn" onClick={confirmLogout}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MAIN */}
      <main className="cleartokenpage-main">

        {/* CARD */}
        <div className="cleartokenpage-card">
          <div className="cleartokenpage-card-header">
            <h2>Clear Current Token</h2>
            <p>Mark the current patient as completed and advance the queue</p>

            <h3>
              Token Number: <span>{current ? current.tokenNumber : "—"}</span>
            </h3>
          </div>

          {/* PATIENT INFO */}
          {current ? (
            <div className="cleartokenpage-info-card">
              <h4>Patient Information</h4>

              <div className="cleartokenpage-info-grid">
                <div>
                  <p className="cleartokenpage-label">Name</p>
                  <p className="cleartokenpage-value">{current.name}</p>
                </div>

                <div>
                  <p className="cleartokenpage-label">CID</p>
                  <p className="cleartokenpage-value">{current.cid}</p>
                </div>

                <div>
                  <p className="cleartokenpage-label">Email</p>
                  <p className="cleartokenpage-value">{current.email || "—"}</p>
                </div>

                <div>
                  <p className="cleartokenpage-label">Age</p>
                  <p className="cleartokenpage-value">{current.age}</p>
                </div>

                <div className="cleartokenpage-fullwidth">
                  <p className="cleartokenpage-label">Chief Complaint</p>
                  <p className="cleartokenpage-value">{current.complaint}</p>
                </div>
              </div>
            </div>
          ) : (
            <p className="no-queue">No patients in the queue.</p>
          )}

          <button className="cleartokenpage-btn" onClick={clearToken}>
            Clear Token
          </button>
        </div>

        {/* QUEUE OVERVIEW */}
        <section className="cleartokenpage-queue">
          <h3>Queue Overview</h3>
          <p>Current status of your chamber</p>

          <div className="cleartokenpage-queue-grid">
            <div className="cleartokenpage-queue-box">
              <p className="cleartokenpage-label">Location</p>
              <p className="cleartokenpage-value">
                {current ? current.chamberAssignment : "—"}
              </p>
            </div>

            <div className="cleartokenpage-queue-box">
              <p className="cleartokenpage-label">Current Token</p>
              <p className="cleartokenpage-value">
                {current ? current.tokenNumber : "—"}
              </p>
            </div>

            <div className="cleartokenpage-queue-box">
              <p className="cleartokenpage-label">Waiting</p>
              <p className="cleartokenpage-value">
                {queue.length > 0 ? queue.length - 1 : 0}
              </p>
            </div>
          </div>
        </section>

      </main>

      <footer className="cleartokenpage-footer">
        <p>Last Updated Just Now</p>
        <span>© 2025 Q-Less. All Rights Reserved.</span>
      </footer>
    </div>
  );
}

export default Detail;
